export enum TypingTestFontSize {
  VerySmall = 'verySmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  VeryLarge = 'veryLarge',
}

export enum JuicynessLevel {
  Off = 'off',
  Low = 'low',
  Mid = 'mid',
}
